import {
    WORK_PREFRENCE_REQUEST,
    WORK_PREFRENCE_SUCCESS,
    WORK_PREFRENCE_FAIL
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    result: [],
    msg: "",
    error: "",
  };
  
  const WorkPrefrenceReducer = (state = initialState, action) => {
    switch (action.type) {
      case WORK_PREFRENCE_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case WORK_PREFRENCE_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case WORK_PREFRENCE_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default WorkPrefrenceReducer;
  